import "./wh0.scss";

import React, { Fragment, useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";

import { Case, Switch } from "@app/contexts";
import { Central_TaburiMain_Panorama } from "@app/state/constants";

/* -------------------------------------------------------------------------- */
//TODO: #39 user and group buttongroup is out of sync when returning to page in extended mode
/* -------------------------------------------------------------------------- */
const WindowHeadLine = () => {
  const location = useLocation();
  const currentForm = useRef(null);
  const prevCl = useRef("0px");
  const prevCw = useRef("0px");
  const prevUGLeft = useRef("0px");
  const prevUGw = useRef("0px");

  const params = new URLSearchParams(location?.search);
  const form = params.get("form"); // Panoramic | [... TaburiMain]
  currentForm.current = form;
  // important information:
  //const sender = params.get('sender'); //Extended | Quick
  // the creation order and the position from left to right in the form.
  // except user = 1001, group = 1002
  // const tag = params.get('tag');
  const cLeft = params.get("compoleft");
  const cWidth = params.get("compowidth");
  const keyWord = params.get("keyword");
  //
  const btnLeft = useMemo(() => {
    if (["user", "group"].includes(keyWord)) {
      return prevCl.current;
    }
    prevCl.current = `${parseInt(cLeft) || 0}px`;
    return prevCl.current;
  }, [cLeft, keyWord]);

  const btnWidth = useMemo(() => {
    if (["user", "group"].includes(keyWord)) {
      return prevCw.current;
    }
    prevCw.current = `${parseInt(cWidth) || 0}px`;
    return prevCw.current;
  }, [cWidth, keyWord]);

  const userGroupLeft = useMemo(() => {
    if (!["user", "group"].includes(keyWord)) {
      return prevUGLeft.current;
    }
    prevUGLeft.current = `${parseInt(cLeft) || 0}px`;
    return prevUGLeft.current;
  }, [cLeft, keyWord]);

  const userGroupWidth = useMemo(() => {
    if (!["user", "group"].includes(keyWord)) {
      return prevUGw.current;
    }
    prevUGw.current = `${parseInt(cWidth) || 0}px`;
    return prevUGw.current;
  }, [cWidth, keyWord]);

  // fires animation on each button click:
  useEffect(() => {
    const el = document.getElementById("anidot");
    if (el) {
      el.classList.remove("loading-dot");
      // triggering reflow
      void el.offsetWidth;
      el.classList.add("loading-dot");
    }
  }, [btnLeft]);

  return (
    <div className="k-form xline" style={{ height: "4px" }}>
      <div
        id={"anidot"}
        className={"loading-dot"}
        style={{ "--ml": btnLeft } as React.CSSProperties}
      />

      <div
        className="selection"
        style={{ transform: `translateX(${btnLeft})`, width: btnWidth }}
      />

      <Switch value={currentForm.current}>
        <Case when={Central_TaburiMain_Panorama}>
          <div
            className="user-group"
            style={{
              transform: `translateX(${userGroupLeft})`,
              width: userGroupWidth,
            }}
          />
        </Case>
      </Switch>
    </div>
  );
};
export default WindowHeadLine;
